import { useState } from "react";
import { Landmark, Receipt, FileText } from "lucide-react";
import { T } from "../../ui/tokens";
import { useEmpresa } from "../../context/EmpresaContext";
import ExtratoBancarioTab from "./ExtratoBancarioTab";
import FaturasPendentesTab from "./FaturasPendentesTab";

type Tab = "extrato" | "fornecedores" | "clientes";

const TABS: { id: Tab; label: string; Icon: typeof Landmark }[] = [
  { id: "extrato", label: "Extrato Bancário", Icon: Landmark },
  { id: "fornecedores", label: "Faturas Fornecedores", Icon: Receipt },
  { id: "clientes", label: "Faturas Clientes", Icon: FileText },
];

// A empresa já vem escolhida do EcraEmpresaSelect (useEmpresa()) -- este
// componente não tem seletor próprio nenhum. Antes tinha um <select> aqui
// (independente do resto da app, com a sua própria lógica de "primeiro
// render sem valor"), que ficava dessincronizado da empresa selecionada
// globalmente assim que o utilizador a mudava depois do primeiro render.
export default function ConciliacaoView() {
  const { empresa } = useEmpresa();
  const [tab, setTab] = useState<Tab>("extrato");

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 9.5, fontWeight: 800, letterSpacing: ".13em", textTransform: "uppercase", color: T.blue, marginBottom: 7 }}>Movimentos bancários</div>
        <h1 style={{ fontSize: 28, lineHeight: 1.1, fontWeight: 780, color: T.text, margin: 0, letterSpacing: "-0.035em" }}>Conciliação</h1>
        <p style={{ fontSize: 13, lineHeight: 1.5, color: T.textMid, margin: "7px 0 0" }}>Escolhe uma conta e trabalha apenas os movimentos do período importado.</p>
      </div>

      <div style={{ display: "inline-flex", gap: 4, padding: 4, marginBottom: 24, border: `1px solid ${T.border}`, borderRadius: 12, background: "#fff", flexWrap: "wrap", boxShadow: "0 1px 2px rgba(16,24,40,.03)" }}>
        {TABS.map((t) => {
          const active = tab === t.id;
          return (
            <button key={t.id} onClick={() => setTab(t.id)}
              style={{ display: "inline-flex", alignItems: "center", gap: 7, padding: "9px 14px", border: "none", borderRadius: 9, background: active ? "#E6F8F5" : "transparent", cursor: "pointer",
                       fontSize: 12.5, fontWeight: 700, color: active ? T.blue : T.textMid }}>
              <t.Icon size={15} strokeWidth={2.2} /> {t.label}
            </button>
          );
        })}
      </div>

      {tab === "extrato" && <ExtratoBancarioTab empresa={empresa} />}
      {tab === "fornecedores" && <FaturasPendentesTab empresa={empresa} tipo="fornecedor" />}
      {tab === "clientes" && <FaturasPendentesTab empresa={empresa} tipo="cliente" />}
    </div>
  );
}
